/**
 * A validation rule that ensures the input’s value has asci chars only
 */
const asci = function (node) {
  const regex = /^[\u0020-\u007F]+$/;
  return regex.test(node.value);
}

// override default rule behaviors for your custom rule
asci.blocking = true
asci.skipEmpty = true
asci.debounce = 20 // milliseconds
asci.force = false

export default asci
